import { ensureArray } from '@lglp/utils';
import { normalize as normalizr } from 'normalizr';
import ApiSearchResponse from 'prismic-javascript/types/ApiSearchResponse';
import { Document as PrismicDocument } from 'prismic-javascript/types/documents';
import { compose, map, prop } from 'ramda';

import { CustomType, CustomTypes } from '../../../schema/prismic';
import { DocumentType } from '../../../types/document';

const schemaToType = ({
  id,
  schema,
}: {
  id: string;
  schema: string;
}): { id: string; type: string } => ({
  type: schema,
  id,
});

const applyNormalizr = (
  payload: any
): { result: Array<any>; entities: any } => ({
  result: [],
  ...normalizr(ensureArray(payload), CustomTypes),
});

const addType = (payload: any) => ({
  ...payload,
  result: map(schemaToType, prop('result', payload)),
});

export const normalize: (prismicDocument: any) => {
  result: Array<any>;
  entities: any;
} = compose(addType, applyNormalizr);

export const normalizePaginatedCustomTypes = (
  paginatedPrismicDocument?: ApiSearchResponse
): {
  results: { id: string; type: string }[];
  entities: any;
  page: number;
  total_pages: number;
  next_page?: string;
  prev_page?: string;
  total_results_size: number;
} => {
  if (!paginatedPrismicDocument) {
    return {
      entities: {},
      results: [],
      page: 0,
      total_pages: 0,
      total_results_size: 0,
    };
  }

  const { result = [], entities } = normalizr(
    paginatedPrismicDocument.results,
    CustomTypes
  );

  return {
    page: paginatedPrismicDocument.page,
    total_pages: paginatedPrismicDocument.total_pages,
    total_results_size: paginatedPrismicDocument.total_results_size,
    next_page: paginatedPrismicDocument.next_page,
    prev_page: paginatedPrismicDocument.prev_page,
    entities,
    results: result.map(
      ({ schema, ...rest }: { schema: string; id: string }) => ({
        type: schema,
        ...rest,
      })
    ),
  };
};

export const normalizeCustomType = (
  prismicDocument: PrismicDocument
): {
  result: any;
  entities: Record<string, any>;
} => {
  try {
    const { result: { schema, id } = {}, entities } = normalizr(
      prismicDocument,
      CustomType
    );

    return {
      result:
        entities[
          schema === DocumentType.MEDIA_PRESS_RELEASE
            ? DocumentType.PRESS_RELEASE
            : schema
        ]?.[id],
      entities,
    };
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('Error during normalization : ', err);
    throw err;
  }
};
